<script lang="ts">
  import { Button } from 'bits-ui';
  import { toast } from '$lib/stores/toast.js';
  import { fly, fade } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';
  import { CheckCircle2, XCircle, Info } from 'lucide-svelte';
</script>

{#if $toast.length > 0}
  <div
    class="pointer-events-none fixed inset-x-0 top-0 z-100 flex flex-col items-center gap-2 px-4"
    style="padding-top: max(0.75rem, env(safe-area-inset-top, 0px));"
    aria-live="polite"
  >
    {#each $toast as item (item.id)}
      <div
        class="pointer-events-auto w-full max-w-sm rounded-2xl border border-transparent px-4 py-3 shadow-lg backdrop-blur-md
          {item.variant === 'success' ? 'bg-emerald-50/95 text-emerald-900 dark:bg-emerald-950/90 dark:text-emerald-100' : ''}
          {item.variant === 'error' ? 'bg-red-50/95 text-red-900 dark:bg-red-950/90 dark:text-red-100' : ''}
          {item.variant === 'info' ? 'bg-brand-50/95 text-brand-900 dark:bg-brand-950/90 dark:text-brand-100' : ''}"
        in:fly={{ y: -24, duration: 300, easing: cubicOut }}
        out:fade={{ duration: 200 }}
      >
        <div class="flex items-start gap-2.5">
          {#if item.variant === 'success'}
            <CheckCircle2 class="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
          {:else if item.variant === 'error'}
            <XCircle class="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
          {:else}
            <Info class="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
          {/if}
          <p class="flex-1 text-sm font-medium leading-snug">{item.message}</p>
          <Button.Root
            type="button"
            class="shrink-0 rounded-lg border-0 bg-transparent p-0.5 opacity-60 shadow-none transition-opacity hover:opacity-100"
            aria-label="Dismiss"
            onclick={() => toast.dismiss(item.id)}
          >
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </Button.Root>
        </div>
      </div>
    {/each}
  </div>
{/if}
